import React from 'react';
import MypagAsDetailContainer from 'containers/MypagAsDetailContainer/MypagAsDetailContainer';

export default function MypagAsDetailPage() {
    return (
        <MypagAsDetailContainer />
    )
}
